import { inject, Injectable, signal } from '@angular/core';
import { ValidationApiService } from '@api-client/validation.api';
import { UserService } from '@core/services/user/user.service';

@Injectable({ providedIn: 'root' })
export class PendingValidationsBadgeService {
  private readonly validationApiService = inject(ValidationApiService);
  private readonly userService = inject(UserService);

  readonly count = signal(0);

  refresh(): void {
    const validatorId = this.userService.userName();
    const group = this.userService.userGroup();

    if (!validatorId || !group) {
      this.count.set(0);
      return;
    }

    this.validationApiService.countPendingValidations(validatorId, group).subscribe({
      next: (data) => this.count.set(data.count ?? 0),
      error: (error) => {
        console.error('Error loading pending validations count:', error);
        this.count.set(0);
      },
    });
  }
}
